import { useContext } from 'react';
import { IUserContext, UserContext } from './User.context';

export const useUserContext = (): IUserContext => {
	return useContext(UserContext);
};
